import {
  createTeacherFeeRequest,
  getTeacherFeeTypesRequest,
  getTeacherFeesRequest,
} from '../api/teacherFee.api';

const extractList = (payload) => {
  if (Array.isArray(payload)) return payload;

  return (
    payload?.data ||
    payload?.items ||
    payload?.results ||
    payload?.fees ||
    payload?.fee_types ||
    payload?.teacher_fee_types ||
    []
  );
};

const pickFirst = (item, keys = []) => {
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }

  return null;
};

const normalizeFeeConfig = (item) => ({
  id: pickFirst(item, ['id', 'teacher_fee_id', 'teacherFeeId']),
  teacherUserId: pickFirst(item, ['teacher_user_id', 'teacherUserId']),
  gradeId: pickFirst(item, [
    'grade_id',
    'gradeId',
    'grade_type_id',
    'gradeTypeId',
    'grade_type_grade_id',
  ]),
  feeFor: pickFirst(item, ['fee_for', 'feeFor', 'fee_type_code', 'feeTypeCode', 'code']) || '',
  feeForLabel:
    pickFirst(item, ['fee_for_name', 'feeForName', 'fee_type_name', 'feeTypeName', 'name', 'title', 'label']) || '',
  fee: pickFirst(item, ['fee', 'amount', 'value']) ?? '',
  gradeTypeDesc:
    pickFirst(item, [
      'grade_type_desc',
      'gradeTypeDesc',
      'grade_name',
      'gradeName',
      'name',
      'title',
      'label',
    ]) || '',
  gradeName: pickFirst(item, ['grade_type_name', 'name']) || '',
  raw: item,
});

const normalizeFeeType = (item, index) => ({
  code: pickFirst(item, ['code', 'fee_for', 'feeFor', 'fee_type_code', 'feeTypeCode']) || `fee-type-${index}`,
  name: pickFirst(item, ['name', 'title', 'label', 'fee_for_name', 'feeForName']) || 'Unknown',
  raw: item,
});

export const fetchTeacherFees = async (teacherUserId) => {
  const res = await getTeacherFeesRequest(teacherUserId);
  return extractList(res.data).map(normalizeFeeConfig);
};

export const fetchTeacherFeeTypes = async () => {
  const res = await getTeacherFeeTypesRequest();
  return extractList(res.data).map(normalizeFeeType);
};

export const createTeacherFee = async (data) => {
  const res = await createTeacherFeeRequest(data);
  return res.data;
};
